import { useField } from 'formik'
import type { ExportsExporterQuery } from 'generated/resources/graphql'

import SelectField from 'modules/core/components/SelectField'
import i18n from 'modules/core/lib/i18n'

type UniversalExportsExporterGroupColumn =
  ExportsExporterQuery['universalExports']['exportersConnection']['nodes'][number]['groupableColumns'][number]

interface Props {
  groupableColumns: UniversalExportsExporterGroupColumn[]
}

const GroupableColumn = ({ groupableColumns }: Props) => {
  const [field, { error }, { setValue }] = useField<string | undefined>('groupColumn')

  if (!groupableColumns) return null

  return (
    <SelectField
      {...field}
      none={i18n.t('common.none')}
      label={i18n.t('universal_exports.group_column.label_v2')}
      description={i18n.t('universal_exports.group_column.description_v2')}
      options={groupableColumns.map((groupableColumn) => ({
        label: groupableColumn.label,
        value: groupableColumn.name,
      }))}
      error={error}
      onChange={(value) => setValue(value != '' ? value : undefined)}
    />
  )
}
export default GroupableColumn
